export const isTagetCpaHigherThanBudget = (i18n, budgetAmount, cpa) => cpa && budgetAmount && i18n && i18n.parseDecimal(String(budgetAmount)) < cpa;

export const getLogString = (checkValue, budgetAmount, cpa, scenario, onSave) => `[TargetCpaValueCheck][${scenario}] TargetCpaValue warning, flow: ${onSave ? 'OnSave' : 'OnEdit'} checkValue: ${checkValue}, budget: ${budgetAmount}, cpa:  ${cpa}`;
